import { cloneDeep } from "lodash";

const PUSH_HARDWARE = "app/hardware/PUSH_HARDWARE";
const RESET_HARDWARE = "app/hardware/RESET_HARDWARE";
const PUSH_MERCURY_HARDWARE = "app/hardware/PUSH_MERCURY_HARDWARE";
const RESET_MERCURY_HARDWARE = "app/hardware/RESET_MERCURY_HARDWARE";
const SET_LOADING = "app/hardware/SET_LOADING";
const SET_REFRESH = "app/hardware/SET_REFRESH";
const SET_MERCURY_HARDWARE_LOADING = "app/hardware/SET_MERCURY_HARDWARE_LOADING";
const SET_MERCURY_HARDWARE_REFRESH = "app/hardware/SET_MERCURY_HARDWARE_REFRESH";
const SET_ERROR = "app/hardware/SET_ERROR";

const initialState = {
  hardware: null,
  mercuryHardware: null,
  refresh: false,
  loading: false,
  mercuryHardwareRefresh: false,
  mercuryHardwareLoading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PUSH_HARDWARE: {
      const clonedState = cloneDeep(state);

      const hardware = clonedState.hardware ?? [];

      return {
        ...clonedState,
        hardware: [...hardware, ...action.payload]
      };
    }

    case RESET_HARDWARE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        hardware: null
      };
    }

    case PUSH_MERCURY_HARDWARE: {
      const clonedState = cloneDeep(state);

      const mercuryHardware = clonedState.mercuryHardware ?? [];

      return {
        ...clonedState,
        mercuryHardware: [...mercuryHardware, ...action.payload]
      };
    }

    case RESET_MERCURY_HARDWARE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        mercuryHardware: null
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_MERCURY_HARDWARE_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        mercuryHardwareRefresh: action.payload
      };
    }

    case SET_MERCURY_HARDWARE_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        mercuryHardwareLoading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const pushHardware = (hardware) => ({
  type: PUSH_HARDWARE,
  payload: hardware
});

export const resetHardware = () => ({
  type: RESET_HARDWARE
});

export const pushMercuryHardware = (mercuryHardware) => ({
  type: PUSH_MERCURY_HARDWARE,
  payload: mercuryHardware
});

export const resetMercuryHardware = () => ({
  type: RESET_MERCURY_HARDWARE
});

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setMercuryHardwareLoading = (loading) => ({
  type: SET_MERCURY_HARDWARE_LOADING,
  payload: loading
});

export const setMercuryHardwareRefresh = (refresh) => ({
  type: SET_MERCURY_HARDWARE_REFRESH,
  payload: refresh
});

export const setError = (error) => ({ type: SET_ERROR, payload: error });
